import axios from 'axios';

// API URL - uses environment variable in production, localhost in development
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create axios instance with defaults
const instance = axios.create({
  baseURL: API_URL,
  timeout: 120000, // 2 minutes for large file uploads
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to add the auth token to every request
instance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add it to the headers
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      console.log('Adding auth token to request:', config.url);
    } else {
      console.warn('No authentication token found for request:', config.url);
      
      // Check if user data exists but token doesn't
      const userData = localStorage.getItem('user');
      if (userData) {
        console.warn('User data exists but no token - possible auth issue');
      }
    }
    
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 errors (unauthorized)
    if (error.response && error.response.status === 401) {
      console.warn('Authentication error (401) - you may need to log in again');
      
      // Log more details about the failed request
      console.error('Request that failed with 401:', {
        url: error.config.url,
        method: error.config.method,
        headers: error.config.headers,
        hasAuthHeader: !!error.config.headers.Authorization
      });
      
      // Check localStorage token status
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      console.log('Auth status: Token exists:', !!token, 'User exists:', !!user);
      
      // Here we could also implement automatic logout or token refresh
      // localStorage.removeItem('token');
      // window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default instance;
